import { useDispatch, useSelector } from 'react-redux';
import { FiltersSideBar } from '@components/filters/v2/FiltersSideBar';
import React from 'react';
import { getDealFinderResultsData, getHasAppliedFilters } from '@state/deal-finder-results/dealFinderResultsSelectors';
import { Filter } from '@model/iceberg';
import { FiltersAdapter } from '@model/iceberg/filters/deal-finder/filters-adapter';
import { setFilters } from '@state/deal-finder-results/dealFinderResultsOperations';

export interface FiltersSideBarContainerProps {
  title?: boolean;
}

export const FiltersSideBarContainer = (props: FiltersSideBarContainerProps) => {
  const {
    facets: { filters }
  } = useSelector(getDealFinderResultsData);
  const hasAppliedFilters: boolean = useSelector(getHasAppliedFilters);
  const dispatch = useDispatch();
  const handleOnFiltersChange = (payload: Array<Filter>) => dispatch(setFilters(FiltersAdapter.getQuery(payload)));
  const handleOnReset = () => dispatch(setFilters({}));
  return (
    <FiltersSideBar
      {...props}
      filters={filters}
      hasAppliedFilters={hasAppliedFilters}
      onChange={handleOnFiltersChange}
      onReset={handleOnReset}
      title
    />
  );
};
